<script lang="ts">
import "@cisco-u/link/cu-link.js";

import { defineComponent } from "vue";

import SanitizeUrl from "@/utils/sanitizeUrl";

export default defineComponent({
  emits: ["clicked"],
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  computed: {
    cleanUrl() {
      return SanitizeUrl(this.url);
    },
  },
});
</script>

<template>
  <cu-link
    :href="cleanUrl"
    tabindex="0"
    rel="noopener"
    @click.prevent="$emit('clicked')"
    @keyup.enter.prevent="$emit('clicked')"
    @keyup.space.prevent="$emit('clicked')"
  >
    <slot />
  </cu-link>
</template>
